import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../../../redux';
import { startCreateSprint, createSprint, loadSetting } from '../../../redux';
import { Alert } from '../../../components';
import SprintForm from '../SprintForm/SprintForm';
import moment from 'moment';
import { Moment } from 'moment';

const nextDay = (day: number) : Moment => {
    const today = moment().isoWeekday();
    return today <= day ?
        moment().isoWeekday(day) :
        moment().add(1, 'weeks').isoWeekday(day);
}

function SprintCreate() {
    const { t }    = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { sprint, created, creatingError } = useAppSelector((state: RootState) => state.sprints);
    const { setting } = useAppSelector((state: RootState) => state.settings);

    useEffect(() => {
        dispatch(loadSetting('default'));
    }, [dispatch]);

    useEffect(() => {
        const startWeekday = Number(setting?.sprints?.start?.weekday) || 1;
        const endWeekday = Number(setting?.sprints?.end?.weekday) || 7;
        const startTime = setting?.sprints?.start?.time || '00:00';
        const endTime = setting?.sprints?.end?.time || '23:59';

        const [startH, startM] = startTime.split(':').map(Number);
        const [endH, endM] = endTime.split(':').map(Number);

        const start = nextDay(startWeekday).hour(startH || 0).minute(startM || 0).second(0).millisecond(0);
        // End weekday relative to the same ISO week as start
        const end = start.clone().isoWeekday(endWeekday)
            .hour(endH || 23).minute(endM || 59).second(59).millisecond(999);
        if (end.isBefore(start))
            end.add(1, 'week');

        const defaultSprint = {
            name: start.format('GGGG-WW'),
            startAt: start.toISOString(),
            stopAt: end.toISOString(),
        };
        dispatch(startCreateSprint(defaultSprint));
    }, [dispatch, setting]);

    const submit = function (values: AnyObj) : void {
        dispatch(createSprint(values));
    }

    if (created)
        navigate(`/sprints/${sprint._id}`);

    return (
        <div className="SprintCreate">
            <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 py-0 sm:px-6 lg:px-8">
                <div className="my-2 mx-auto lg:flex lg:items-center lg:justify-between">
                    <div>
                        <h2 className="text-3xl font-bold tracking-tight text-black-900">
                            { t('sprints.add_a_sprint') }
                        </h2>
                    </div>
                </div>
            </header>
            {creatingError && (
                <div className="flex-1">
                    <Alert title={t('sprints.creation_failed') + ' : ' + creatingError} color="failure" icon="warning" />
                </div>
            )}
            <main className="mx-6 my-6 shadow">
                {sprint && (!sprint._id) && (
                    <SprintForm isCreation={true} initialValues={sprint} onSubmit={submit} />
                )}
            </main>
        </div>
    );
}

export default SprintCreate;
